import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveOrderFulfillmentContainerStationManualAmountMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
  manual_amount: Types.ContainerTypeAmountInput;
  container_station_id: Types.Scalars['ID'];
}>;


export type RemoveOrderFulfillmentContainerStationManualAmountMutation = { __typename?: 'Mutation', removeOrderFulfillmentContainerStationManualAmount: { __typename?: 'OrderFulfillment', id: string } };


export const RemoveOrderFulfillmentContainerStationManualAmountDocument = gql`
    mutation RemoveOrderFulfillmentContainerStationManualAmount($order_fulfillment_id: ID!, $manual_amount: ContainerTypeAmountInput!, $container_station_id: ID!) {
  removeOrderFulfillmentContainerStationManualAmount(
    order_fulfillment_id: $order_fulfillment_id
    manual_amount: $manual_amount
    container_station_id: $container_station_id
  ) {
    id
  }
}
    `;
export type RemoveOrderFulfillmentContainerStationManualAmountMutationFn = Apollo.MutationFunction<RemoveOrderFulfillmentContainerStationManualAmountMutation, RemoveOrderFulfillmentContainerStationManualAmountMutationVariables>;

/**
 * __useRemoveOrderFulfillmentContainerStationManualAmountMutation__
 *
 * To run a mutation, you first call `useRemoveOrderFulfillmentContainerStationManualAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderFulfillmentContainerStationManualAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderFulfillmentContainerStationManualAmountMutation, { data, loading, error }] = useRemoveOrderFulfillmentContainerStationManualAmountMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *      manual_amount: // value for 'manual_amount'
 *      container_station_id: // value for 'container_station_id'
 *   },
 * });
 */
export function useRemoveOrderFulfillmentContainerStationManualAmountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrderFulfillmentContainerStationManualAmountMutation, RemoveOrderFulfillmentContainerStationManualAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrderFulfillmentContainerStationManualAmountMutation, RemoveOrderFulfillmentContainerStationManualAmountMutationVariables>(RemoveOrderFulfillmentContainerStationManualAmountDocument, options);
      }
export type RemoveOrderFulfillmentContainerStationManualAmountMutationHookResult = ReturnType<typeof useRemoveOrderFulfillmentContainerStationManualAmountMutation>;
export type RemoveOrderFulfillmentContainerStationManualAmountMutationResult = Apollo.MutationResult<RemoveOrderFulfillmentContainerStationManualAmountMutation>;
export type RemoveOrderFulfillmentContainerStationManualAmountMutationOptions = Apollo.BaseMutationOptions<RemoveOrderFulfillmentContainerStationManualAmountMutation, RemoveOrderFulfillmentContainerStationManualAmountMutationVariables>;